import miment from 'miment'
import _ from 'lodash'

export const token = state => {
  let token = state.token
  let expiredAt = miment(Date.parse(token.expiredAt))
  let now = miment()
  if (now.isBefore(expiredAt)) {
    return token.token
  }
  return undefined
}

export const user = state => {
  return state.currentUser
}

export const currentStudentInfo = state => {
  let name = _.get(state.currentUser, 'name', '')
  let studentNo = _.get(state.currentUser, 'studentNo', '')
  if (_.isEmpty(name) && _.isEmpty(studentNo)) {
    return ''
  }
  return `${name}(${studentNo})`
}



// WEBPACK FOOTER //
// ./src/store/getters.js